// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__Bb7CX","buttons":"SendReceipts_buttons__3y8Md","email":"SendReceipts_email__2O1Zn","bookApptTitle":"SendReceipts_bookApptTitle__3YQDu"};